'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { ANNOUNCEMENTS, isPortalPath } from './nav';

export default function AnnouncementBar() {
  const pathname = usePathname();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % ANNOUNCEMENTS.length), 5000);
    return () => clearInterval(t);
  }, []);

  if (isPortalPath(pathname)) return null;

  return (
    <div className="bg-al-maroon/90 font-al-body text-al-cream" role="region" aria-label="Store announcements">
      <p className="al-container flex min-h-9 items-center justify-center py-2 text-center text-[10px] uppercase leading-snug tracking-[0.14em] sm:text-[11px] sm:tracking-[0.22em]" aria-live="polite">
        <span key={index} className="animate-in fade-in duration-500">{ANNOUNCEMENTS[index]}</span>
      </p>
    </div>
  );
}
